<template>
  <div>
    <nav aria-label='breadcrumb'>
      <ol class='breadcrumb'>
        <li class='breadcrumb-item'>
          <a href='#'>{{translations('navbar.purchase_management')}}</a>
        </li>
        <li class='breadcrumb-item'>
          <router-link to='/archive-purchase-overseas-stockings'>{{translations('navbar.archive_oversea_shipment')}}</router-link>
        </li>
        <li class='breadcrumb-item active' aria-current='page'>{{translations('purchase.overseas_purchase_details')}}</li>
      </ol>
    </nav>
    <div class='container-fluid main-container'>
      <div class='d-flex flex-wrap'>
        <div class='left-container'>
          <h5 class='mb-3'>Information</h5>
          <table class='table table-sm table-borderless table-information'>
            <tbody>
            <tr>
              <th>{{ translations('purchase.order_date') }}</th>
              <td>{{$invoiceTools.formatDate(purchaseOverseasInfo.po_date)}}</td>
            </tr>
            <tr>
              <th>{{ translations('purchase.client_order_number') }}</th>
              <td>{{purchaseOverseasInfo.po_no}}</td>
            </tr>
            <tr>
              <th>{{ translations('arrival.supplier') }}</th>
              <td>{{purchaseOverseasInfo.partner_name}}</td>
            </tr>
            <tr>
              <th>{{ translations('purchase.arrival_date') }}</th>
              <td>{{$invoiceTools.formatDate(purchaseOverseasInfo.arrived_at)}}</td>
            </tr>
            <tr>
              <th>{{ translations('purchase.warehouse') }}</th>
              <td>{{ purchaseOverseasInfo.warehouse_name }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class='right-container'>
          <div class='table-scroll' style="margin-top: 25px">
            <table class='table table-sm table-striped table-1000'>
              <thead>
                <tr>
                  <th>Item No.</th>
                  <th>{{ translations('purchase.model') }}</th>
                  <th>{{ translations('purchase.details') }}</th>
                  <th></th>
                  <th>{{ translations('purchase.unit_price') }}</th>
                  <th>{{ translations('purchase.quantity') }}</th>
                  <th></th>
                  <th>{{ translations('purchase.amount') }}</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(detail, i) in purchaseOverseasDetails">
                  <tr :key="i">
                    <td>{{ detail.item_no }}</td>
                    <td>{{ detail.model }}</td>
                    <td>{{ detail.description }}</td>
                    <th class='font-weight-normal'>JPY</th>
                    <td class="left">{{ detail.unit_price.toLocaleString() }}</td>
                    <td class="left">{{ Number(detail.quantity).toLocaleString() }}</td>
                    <td></td>
                    <td class="left">{{ detail.total_unit_price.toLocaleString() }}</td>
                  </tr>
                </template>
                <tr class='bg-lightgreen'>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td class='font-weight-bold'>{{ translations('purchase.total') }}</td>
                  <td class='font-weight-bold left'>{{ Number(grandTotalQuantity).toLocaleString() }}</td>
                  <td class="font-weight-bold left">JPY</td>
                  <td class='font-weight-bold left'>{{ grandTotalUnitPrice.toLocaleString() }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <vue-element-loading :active='isLoading' :is-full-screen='true'/>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import { mapState } from 'vuex'

export default {
  name: 'SinglePurchaseOverseasStockings',
  props: {},
  components: {
    VueElementLoading
  },

  data () {
    return {
      purchaseId: 0,
      purchaseOverseasDetails: [],
      isLoading: true,
      grandTotalUnitPrice: 0,
      grandTotalQuantity: 0,
      purchaseOverseasInfo: {},
      purchase: {}
    }
  },

  watch: {
  },

  computed: {
    ...mapState(['currentLanguage'])
  },

  created () {
    if (!this.$route.query.purchase_id) {
      this.$router.replace('archive-purchase-overseas-stockings')
    }

    this.purchaseId = Number(this.$route.query.purchase_id)
    this.purchase = JSON.parse(this.$route.query.purchase)
    Promise.all([
      this.getPurchaseOverseas()
    ]).then(() => {
      this.isLoading = false
    }).catch(error => {
      this.$toastr.error(error, this.translations('common.error'))
    })
  },

  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    getPurchaseOverseas () {
      this.isLoading = true
      return this.$http.post(this.$api_url.purchase_overseas_detail, { purchase_id: this.purchaseId, purchase: this.purchase }).then(response => {
        const result = response.data
        if (result.status === true) {
          this.purchaseOverseasDetails = result.details
          this.purchaseOverseasInfo = result.information
          this.grandTotalUnitPrice = result.grandTotalUnitPrice
          this.purchaseOverseasDetails.forEach(v => {
            this.grandTotalQuantity += Number(v.quantity)
          })
        } else {
          return Promise.reject(new Error(result.message))
        }
      }).catch(function (error) {
        console.log('SinglePurchaseOverseasStockings:getPurchaseOverseas:catch(error): ', error)
        return Promise.reject(new Error(this.translations('purchase.notice_failed')))
      }).finally(() => {
        this.isLoading = false
      })
    }
  }
}
</script>
